import { Cookies } from 'react-cookie';

import { DevicesOnMapResponse } from './types';

import axiosInterceptor from 'api/interceptor/axiosClient';

export const getUnmountedMCT = async (siteSlug: string) => {
  const cookies = new Cookies();
  const token = cookies.get('local_access_token');
  const response = await axiosInterceptor.get(`api/v1/traps/site/${siteSlug}/unmounted-trap`, {
    headers: {
      Authorization: token,
    },
  });
  return response.data as DevicesOnMapResponse;
};
